"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import ChevronDoubleDownIcon from "@heroicons/react/24/solid/ChevronDoubleDownIcon";
import SwatchIcon from "@heroicons/react/24/solid/SwatchIcon";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";

interface Props {
  services: {
    firstServices: any;
    secondServices: any;
    thirdServices: any;
    totalCount: number;
  };
}

const SERVICE_LIMIT = 8;

export default function PlaceDetailsServices(props: Props) {
  const [seeMore, setSeeMore] = useState(false);

  useEffect(() => {
    if (
      props.services?.firstServices?.length <= SERVICE_LIMIT &&
      props.services?.secondServices?.length <= SERVICE_LIMIT &&
      props.services?.thirdServices?.length <= SERVICE_LIMIT
    ) {
      setSeeMore(true);
    }
  }, [props.services]);

  const getTitle = (service) =>
    service?.service?.descriptions?.[0]?.title || "";

  return (
    <div
      id={VENUE_TABS.SERVICES}
      className={cn(
        "w-full mt-6 flex flex-col gap-4 rounded-[32px] border border-gray-secondary p-4 lg:max-w-[895px]",
        !seeMore ? "md:max-h-[600px]" : "h-auto",
      )}
    >
      <div className="px-2 font-bold py-[6px] flex gap-2 rounded-full text-sm w-full text-primary bg-stone-50">
        <SwatchIcon className="size-6" />
        <h2>Hizmetler</h2>
        <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
          {props.services.totalCount || 0}
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between relative gap-2 text-sm text-primary font-[500]">
        {props?.services?.firstServices?.length > 0 && (
          <div className="flex lg:w-1/3 relative gap-2 h-full left-0">
            <ul className="p-2">
              {props.services?.firstServices
                .slice(0, SERVICE_LIMIT)
                .map((service: string, index: number) => {
                  return <li key={index}>• {getTitle(service)}</li>;
                })}
              {seeMore && props.services?.firstServices?.length > 0 && (
                <>
                  {props.services?.firstServices
                    .slice(SERVICE_LIMIT)
                    .map((service: string, index: number) => {
                      return <li key={index}>• {getTitle(service)}</li>;
                    })}
                </>
              )}
            </ul>

            <div className="h-full absolute right-0 bg-gray-secondary w-[1px]" />
          </div>
        )}

        {props?.services?.secondServices?.length > 0 && (
          <div className="flex lg:w-1/3 relative gap-2 h-full left-0">
            <ul className="p-2">
              {props.services?.secondServices
                .slice(0, SERVICE_LIMIT)
                .map((service: string, index: number) => {
                  return <li key={index}>• {getTitle(service)}</li>;
                })}
              {seeMore && props.services?.secondServices?.length > 0 && (
                <>
                  {props.services?.secondServices
                    .slice(SERVICE_LIMIT)
                    .map((service: string, index: number) => {
                      return <li key={index}>• {getTitle(service)}</li>;
                    })}
                </>
              )}
            </ul>
            <div className="h-full absolute right-0 bg-gray-secondary w-[1px]" />
          </div>
        )}

        {props?.services?.thirdServices?.length > 0 && (
          <div className="flex lg:w-1/3 relative gap-2 h-full left-0">
            <ul className="p-2">
              {props.services?.thirdServices
                .slice(0, SERVICE_LIMIT)
                .map((service: string, index: number) => {
                  return <li key={index}>• {getTitle(service)}</li>;
                })}
              {seeMore && props.services?.thirdServices?.length > 0 && (
                <>
                  {props.services?.thirdServices
                    .slice(SERVICE_LIMIT)
                    .map((service: string, index: number) => {
                      return <li key={index}>• {getTitle(service)}</li>;
                    })}
                </>
              )}
            </ul>
            <div className="h-full absolute right-0 bg-gray-secondary w-[1px]" />
          </div>
        )}

        {!seeMore && (
          <div className="absolute bottom-0 w-full flex justify-center items-end h-[98px] bg-gradient-to-b from-[#ffffff00] to-[#fff]">
            <Button
              onClick={() => setSeeMore(true)}
              className="border border-assistant bg-gray-secondary text-[10px] hover:bg-gray-secondary rounded-full 
                    text-assistant font-bold"
            >
              <ChevronDoubleDownIcon className="size-4" />
              Tüm Hizmetleri Göster
              <ChevronDoubleDownIcon className="size-4" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
